import React from "react";
import useInbox from "hooks/useInbox.ts";
import ProductTourWrapper from "../../Reusable/ProductTour/ProductTourWrapper.js";

const InboxTourWrapper = () => {
  const { getIsFetching } = useInbox();

  return <ProductTourWrapper isPageReady={!getIsFetching()} />;
};

export default InboxTourWrapper;
